import React from 'react';
import PropTypes from 'prop-types';
// import keycode from 'keycode';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableFooter from '@mui/material/TableFooter';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
// import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import DeleteIcon from '@mui/icons-material/Delete';
import {Pagination, Stack} from "@mui/material";
import Add from "@mui/icons-material/Add";
import * as XLSX from "xlsx";
import {saveAs} from "file-saver";

function toPersianNum(num, dontTrim) {

    if (num === '' || num === null) {
        return '';
    }

    var i = 0,

        dontTrim = dontTrim || false,

        num = dontTrim ? num.toString() : num.toString().trim(),
        len = num.length,

        res = '',
        pos,

        persianNumbers = typeof persianNumber == 'undefined' ?
            ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'] :
            persianNumbers;

    for (; i < len; i++)
        if ((pos = persianNumbers[num.charAt(i)]))
            res += pos;
        else
            res += num.charAt(i);

    return res;
};

function formatPriceWithComma(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


let counter = 0;

function createData(name, calories, fat, carbs, protein) {
    counter += 1;
    return {id: counter, name, calories, fat, carbs, protein};
}

const columnData = [
    // {id: 'name', align: true, disablePadding: true, label: 'Dessert (100g serving)'},
    {id: 'calories', align: true, disablePadding: false, label: 'نام اقامتگاه'},
    {id: 'fat', align: true, disablePadding: false, label: 'مبلغ (تومان)'},
    {id: 'carbs', align: true, disablePadding: false, label: 'کمیسیون (تومان)'},
    {id: 'protein', align: true, disablePadding: false, label: 'تاریخ سفارش'},
    {id: 'protein', align: true, disablePadding: false, label: 'شرکت'},
    {id: 'protein', align: true, disablePadding: false, label: 'وضعیت'},
    // {id: 'protein', align: true, disablePadding: false, label: 'وضعیت'},
    // {id: 'protein', align: true, disablePadding: false, label: 'عملیات'},
];

const rows = [
    {id: 1, name: 'محصول A', price: 100},
    {id: 2, name: 'محصول B', price: 200},
];

class DataTableHead extends React.Component {
    static propTypes = {
        numSelected: PropTypes.number.isRequired,
        onRequestSort: PropTypes.func.isRequired,
        onSelectAllClick: PropTypes.func.isRequired,
        order: PropTypes.string.isRequired,
        orderBy: PropTypes.string.isRequired,
        rowCount: PropTypes.number.isRequired,
    };

    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const {onSelectAllClick, order, orderBy, numSelected, rowCount} = this.props;

        return (
            <TableHead>
                <TableRow>
                    {/*<TableCell align='right' >*/}
                    {/*  <Checkbox color="primary"*/}
                    {/*            indeterminate={numSelected > 0 && numSelected < rowCount}*/}
                    {/*            checked={numSelected === rowCount}*/}
                    {/*            onChange={onSelectAllClick}*/}
                    {/*  />*/}
                    {/*</TableCell>*/}

                    <TableCell
                        key='name'
                        align='left'
                        padding='10'
                    >
                        <Tooltip
                            title="Sort"
                            placement='bottom-end'
                            enterDelay={300}
                        >
                            <TableSortLabel
                                active={orderBy === 'name'}
                                direction={order}
                                style={{fontFamily: 'Iran', fontWeight: 'bold', alignItems: 'center'}}
                                onClick={this.createSortHandler('name')}
                            >
                                کد سفارش
                            </TableSortLabel>
                        </Tooltip>
                    </TableCell>


                    {columnData.map(column => {
                        return (
                            <TableCell
                                key={column.id}
                                align='center'
                                sx={{textAlign: 'left'}}
                                padding={column.disablePadding ? 'none' : 'default'}
                            >
                                <Tooltip
                                    title="Sort"
                                    placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === column.id}
                                        direction={order} style={{fontFamily: 'Iran', fontWeight: 'bold', alignItems: 'center'}}
                                        onClick={this.createSortHandler(column.id)}
                                    >
                                        {column.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}


let DataTableToolbar = props => {
    const {numSelected} = props;

    return (
        <Toolbar className="table-header">
            <div className="title">
                {numSelected > 0 ? (
                    <Typography variant="subheading">{numSelected} selected</Typography>
                ) : (
                    <Typography variant="title">Nutrition</Typography>
                )}
            </div>
            <div className="spacer"/>
            <div className="actions">
                {numSelected > 0 && (
                    <Tooltip title="Delete">
                        <IconButton aria-label="Delete">
                            <DeleteIcon/>
                        </IconButton>
                    </Tooltip>
                )}
            </div>
        </Toolbar>
    );
};

DataTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};


class DataTablesEmployee extends React.Component {
    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }

        const data =
            order === 'desc'
                ? this.state.data.sort((a, b) => (b[orderBy] < a[orderBy] ? -1 : 1))
                : this.state.data.sort((a, b) => (a[orderBy] < b[orderBy] ? -1 : 1));

        this.setState({data, order, orderBy});
    };
    handleSelectAllClick = (event, checked) => {
        if (checked) {
            this.setState({selected: this.state.data.map(n => n.id)});
            return;
        }
        this.setState({selected: []});
    };
    handleKeyDown = (event, id) => {
        // if (keycode(event) === 'space') {
        //     this.handleClick(event, id);
        // }
    };
    handleClick = (event, id) => {
        const {selected} = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, id);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        this.setState({selected: newSelected});
    };
    handleChangePage = (event, page) => {
        this.setState({page});
    };
    handleChangeRowsPerPage = event => {
        this.setState({rowsPerPage: event.target.value});
    };
    isSelected = id => this.state.selected.indexOf(id) !== -1;

    constructor(props, context) {
        super(props, context);

        this.state = {
            order: 'asc',
            orderBy: 'calories',
            selected: [],
            data: [
                createData('Cupcake', 305, 3.7, 67, 4.3),
                createData('Donut', 452, 25.0, 51, 4.9),
                createData('Eclair', 262, 16.0, 24, 6.0),
                createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
                createData('Gingerbread', 356, 16.0, 49, 3.9),
                createData('Honeycomb', 408, 3.2, 87, 6.5),
                createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
                createData('Jelly Bean', 375, 0.0, 94, 0.0),
                createData('KitKat', 518, 26.0, 65, 7.0),
                createData('Lollipop', 392, 0.2, 98, 0.0),
                createData('Marshmallow', 318, 0, 81, 2.0),
                createData('Nougat', 360, 19.0, 9, 37.0),
                createData('Oreo', 437, 18.0, 63, 4.0),
            ].sort((a, b) => (a.calories < b.calories ? -1 : 1)),
            page: 0,
            rowsPerPage: 20,
        };

        // console.log('5')
        console.log(this.props.EmployeeList)
        // console.log(this.props.EmployeeList.active);
    }

    exportToExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(rows); // تبدیل داده‌ها به Sheet
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const data = new Blob([excelBuffer], {type: "application/octet-stream"});
        saveAs(data, "table-data.xlsx");
    };

    render() {
        const {data, order, orderBy, selected, rowsPerPage, page} = this.state;

        return (
            <Paper>
                {/*<DataTableToolbar numSelected={selected.length}/>*/}

                {this.props.EmployeeList.length === 0 ?

                    <div style={{
                        width: '100%',
                        display: 'flex',fontFamily: 'Iran',
                        padding: 50,
                        alignItems: 'center',
                        justifyContent: 'center'
                    }}>
                        سفارشی یافت نشد
                    </div>

                    :


                    <div className="flex-auto">
                        <div style={{width: '100%', overflowX: 'auto'}} className="table-responsive-material">
                            <Table style={{minWidth: 70}} className="">
                                <DataTableHead
                                    numSelected={selected.length}
                                    // order={order}
                                    // orderBy={orderBy}
                                    onSelectAllClick={this.handleSelectAllClick}
                                    onRequestSort={this.handleRequestSort}
                                    rowCount={this.props.EmployeeList.length}
                                />


                                {this.props.EmployeeList.length === 0 ?

                                    <div style={{
                                        width: '100%',
                                        display: 'flex',
                                        margin: 20,fontFamily: 'Iran',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}>سفارشی در
                                        لیست نیست !</div>

                                    :
                                    <TableBody>
                                        {this.props.EmployeeList.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => {
                                            const isSelected = this.isSelected(n.id);
                                            return (
                                                <TableRow
                                                    hover
                                                    onClick={event => this.handleClick(event, n.id)}
                                                    onKeyDown={event => this.handleKeyDown(event, n.id)}
                                                    // role="checkbox"
                                                    aria-checked={isSelected}
                                                    tabIndex={-1}
                                                    key={n.id}
                                                    selected={isSelected}
                                                >
                                                    {/*<TableCell >*/}
                                                    {/*  /!*<Checkbox color="primary" checked={isSelected}/>*!/*/}
                                                    {/*</TableCell>*/}
                                                    <TableCell style={{
                                                        fontFamily: 'Iran',
                                                        textAlign: 'right'
                                                    }}
                                                               onClick={() => this.props.onopenedit(n)}
                                                               className=' cursor-p'
                                                               padding="2">{toPersianNum(n.requestId)}</TableCell>
                                                    <TableCell style={{
                                                        fontFamily: 'Iran',
                                                        textAlign: 'right'
                                                    }}
                                                               onClick={() => this.props.onopenedit(n)}
                                                               className=' cursor-p'
                                                               align="center">{toPersianNum(n.productName)}</TableCell>
                                                    <TableCell style={{
                                                        fontFamily: 'Iran',
                                                        textAlign: 'right'
                                                    }}
                                                               onClick={() => this.props.onopenedit(n)}
                                                               className=' cursor-p'
                                                               align="center">{toPersianNum(formatPriceWithComma(n.totalAmount))} تومان</TableCell>
                                                    <TableCell style={{
                                                        fontFamily: 'Iran',
                                                        textAlign: 'right'
                                                    }}
                                                               onClick={() => this.props.onopenedit(n)}
                                                               className=' cursor-p'
                                                               align="center">{toPersianNum(formatPriceWithComma(n.commission))} تومان</TableCell>
                                                    <TableCell style={{
                                                        fontFamily: 'Iran',
                                                        textAlign: 'right'
                                                    }}
                                                               onClick={() => this.props.onopenedit(n)}
                                                               className=' cursor-p'
                                                               align="center">{toPersianNum(n.datepersian)}</TableCell>
                                                    <TableCell style={{
                                                        fontFamily: 'Iran',
                                                        textAlign: 'right'
                                                    }}
                                                               onClick={() => this.props.onopenedit(n)}
                                                               className=' cursor-p'
                                                               align="center">{toPersianNum(n.company)}</TableCell>
                                                    <TableCell style={{
                                                        fontFamily: 'Iran',
                                                        textAlign: 'right'
                                                    }}
                                                               onClick={() => this.props.onopenedit(n)}
                                                               className=' cursor-p'
                                                               align="center">{toPersianNum(n.status)}</TableCell>


                                                    {/*{n.active ?*/}

                                                    {/*    <TableCell style={{fontFamily: 'Iran'}}*/}

                                                    {/*               className=' cursor-p'*/}
                                                    {/*               align="center">*/}

                                                    {/*        <Button variant="contained" color="success"*/}
                                                    {/*                onClick={() => this.props.onopenedit(n)}*/}
                                                    {/*                size={"small"}*/}
                                                    {/*        >*/}
                                                    {/*            <span className="iran-font3">فعال</span>*/}
                                                    {/*        </Button>*/}
                                                    {/*    </TableCell>*/}

                                                    {/*    :*/}

                                                    {/*    <TableCell style={{fontFamily: 'Iran'}}*/}

                                                    {/*               className=' cursor-p'*/}
                                                    {/*               align="center">*/}

                                                    {/*        <Button variant="contained" color="error"*/}
                                                    {/*                onClick={() => this.props.onopenedit(n)}*/}
                                                    {/*                size={"small"}*/}
                                                    {/*        >*/}
                                                    {/*            <span className="iran-font3">غیر فعال</span>*/}
                                                    {/*        </Button>*/}
                                                    {/*    </TableCell>*/}

                                                    {/*}*/}


                                                    {/*<TableCell style={{fontFamily: 'Iran'}}*/}

                                                    {/*           className=' cursor-p'*/}
                                                    {/*           align="center">*/}

                                                    {/*    <Button variant="contained"*/}
                                                    {/*            onClick={() => this.props.onopentransaction(n.id)}*/}
                                                    {/*            size={"small"}*/}
                                                    {/*    >*/}
                                                    {/*        <span className="iran-font3">افزایش اعتبار</span>*/}
                                                    {/*    </Button>*/}
                                                    {/*    /!*<Button style={{fontFamily: 'Iran',marginRight:5,marginLeft:5}} variant="contained" onClick={()=> this.props.onopentransaction(n.id)}*!/*/}
                                                    {/*    /!*        size={"small"}*!/*/}
                                                    {/*    /!*        >حذف*!/*/}
                                                    {/*    /!*</Button>*!/*/}

                                                    {/*    /!*<Button style={{fontFamily: 'Iran'}} variant="contained" onClick={()=> this.props.onopentransaction(n.id)}*!/*/}
                                                    {/*    /!*        size={"small"}*!/*/}
                                                    {/*    /!*        >ویرایش*!/*/}
                                                    {/*    /!*</Button>*!/*/}


                                                    {/*</TableCell>*/}
                                                </TableRow>
                                            );
                                        })}
                                    </TableBody>

                                }


                                {/*<TableFooter style={{width:'100%',display:'flex',justifyContent:'center',alignItems:'center'}} >*/}
                                {/*<TableRow>*/}
                                {/*    <TablePagination*/}
                                {/*        style={{direction:'ltr'}}*/}
                                {/*        count={this.props.EmployeeList.length}*/}
                                {/*        rowsPerPage={rowsPerPage}*/}
                                {/*        page={page}*/}
                                {/*        onChangePage={this.handleChangePage}*/}
                                {/*        onChangeRowsPerPage={this.handleChangeRowsPerPage}*/}
                                {/*    />*/}
                                {/*</TableRow>*/}


                                {/*</TableFooter>*/}


                            </Table>
                        </div>
                    </div>

                }


            </Paper>
        );
    }
}

export default DataTablesEmployee;